import styled from 'styled-components';

export const SkeletonNodeListContainer = styled.div<{ $shouldCenterHorizontally: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $shouldCenterHorizontally }) => ($shouldCenterHorizontally ? 'center' : 'flex-start')};
  gap: ${({ theme: { token } }) => token.marginXS}px;
`;
